import { useState, useEffect } from "react";
import "./styles.scss";

const AgeSlider = ({ 
  type = "years", // "years" or "months"
  value = 0,
  onChange,
  min = 0,
  max = 8,
  labels = null,
  disabled = false
}) => {
  const [isDragging, setIsDragging] = useState(false);

  // Generate default labels if not provided
  const getLabels = () => {
    if (labels) return labels;
    if (type === "years") {
      const yearLabels = [];
      for (let i = 0; i <= 8; i++) {
        yearLabels.push(i === 8 ? "8+" : i.toString());
      }
      return yearLabels;
    }
    if (type === "months") {
      return Array.from({ length: 12 }, (_, i) => i.toString());
    }
    return [];
  };

  const sliderLabels = getLabels();
  const actualMax = sliderLabels.length - 1;

  const handleSliderChange = (event) => {
    event.stopPropagation();
    const newValue = parseInt(event.target.value);
    onChange && onChange(newValue);
  };

  const handleMouseDown = (event) => {
    event.stopPropagation();
    setIsDragging(true);
  };

  const handleMouseUp = (event) => {
    event.stopPropagation();
    setIsDragging(false);
  };

  const handleTouchStart = (event) => {
    event.stopPropagation();
    setIsDragging(true);
  };

  const handleTouchEnd = (event) => {
    event.stopPropagation();
    setIsDragging(false);
  };

  const handleTouchMove = (event) => {
    event.stopPropagation();
  };

  const handlePointerDown = (event) => {
    event.stopPropagation();
  };

  const handlePointerUp = (event) => {
    event.stopPropagation();
  };

  useEffect(() => {
    const handleGlobalMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      document.addEventListener('mouseup', handleGlobalMouseUp);
      document.addEventListener('touchend', handleGlobalMouseUp);
    }

    return () => {
      document.removeEventListener('mouseup', handleGlobalMouseUp);
      document.removeEventListener('touchend', handleGlobalMouseUp);
    };
  }, [isDragging]);

  const handleContainerClick = (event) => {
    event.stopPropagation();
  };

  const handleContainerTouch = (event) => {
    event.stopPropagation();
  };

  return (
    <div 
      className={`age-slider ${type} ${disabled ? 'disabled' : ''}`}
      onClick={handleContainerClick}
      onTouchStart={handleContainerTouch}
      onTouchEnd={handleContainerTouch}
      onTouchMove={handleContainerTouch}
    >
      <div className="slider-container">
        <input
          type="range"
          min={min}
          max={actualMax}
          value={value}
          onChange={handleSliderChange}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
          onTouchMove={handleTouchMove}
          onPointerDown={handlePointerDown}
          onPointerUp={handlePointerUp}
          className={`slider ${isDragging ? 'dragging' : ''}`}
          disabled={disabled}
        />
        <div className="slider-track">
          <div 
            className="slider-fill" 
            style={{ width: `${(value / actualMax) * 100}%` }}
          />
        </div>
        <div className="slider-labels">
          {sliderLabels.map((label, index) => (
            <span
              key={index}
              className={`slider-label ${index === value ? 'active' : ''}`}
              style={{ left: `${(index / actualMax) * 100}%` }}
            >
              {label}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AgeSlider;